[
  {
    "id": "klimat",
    "namn": "temperaturen i zonen",
    "signal": "hus.zon.temp",
    "perEnhet": true
  },
  {
    "id": "temperatur",
    "namn": "temperaturen",
    "signal": "hus.zon.temp",
    "ute": "hus.ute.temp",
    "perEnhet": true
  },
  {
    "id": "fukt",
    "namn": "fukten",
    "signal": "hus.fukt",
    "ute": "ute.fukt",
    "perEnhet": true
  },
  {
    "id": "effekt",
    "namn": "effekten",
    "signal": "hus.effekt",
    "perEnhet": true
  },
  {
    "id": "energi",
    "namn": "energin",
    "signal": "hus.energi",
    "perEnhet": true
  },
  {
    "id": "las",
    "namn": "låset",
    "signal": "hus.las",
    "perEnhet": true
  },
  {
    "id": "larm",
    "namn": "larmet",
    "signal": "hus.larm",
    "perEnhet": false
  },
  {
    "id": "dorr",
    "namn": "dörren",
    "signal": "hus.dorr",
    "perEnhet": true
  },
  {
    "id": "fonster",
    "namn": "fönstret",
    "signal": "hus.fonster",
    "perEnhet": true
  },
  {
    "id": "vatten",
    "namn": "vattenläckan",
    "signal": "hus.vattenlacka",
    "perEnhet": true
  },
  {
    "id": "rok",
    "namn": "brandvarnaren",
    "signal": "hus.rok",
    "perEnhet": true
  },
  {
    "id": "kamera",
    "namn": "kameran",
    "signal": null,
    "text": "Kameror (kommer senare)",
    "perEnhet": false
  },
  {
    "id": "regn",
    "namn": "regnet",
    "signal": null,
    "text": "Regnet i väderstationen (kopplas inte)",
    "perEnhet": false
  },
  {
    "id": "utegivare",
    "namn": "utegivaren",
    "signal": "hus.ute.temp",
    "perEnhet": false
  }
]
